import React from 'react';
import {
  Body,
  designSystemToken,
  Headline,
  Icon,
} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import styles from './ShortlistEmptyState.module.scss';

/**
 * Inline empty state shown in the Applications table area when the shortlist
 * filter is on but no creators have been shortlisted (or no shortlisted
 * creators match the current search). Replaces the table itself so the user
 * doesn't see an empty grid plus a banner stacked together.
 *
 * The filter chip stays visible (still in active state) and remains the
 * escape hatch — clicking it again turns the filter off. We intentionally
 * don't duplicate that action as a button here to keep the message focused
 * on the explanation, not the controls.
 */
function ShortlistEmptyState() {
  return (
    <div className={styles.container} data-testid="shortlist-empty-state">
      <div className={styles.content}>
        <Icon
          size="large"
          appearance="neutral"
          name="Navigation-Heart-Line"
          color={designSystemToken('semantic.fg.tertiary')}
          style={{width: 40, height: 40}}
        />
        <Headline size="sm" color={designSystemToken('semantic.fg.primary')}>
          {translate('No shortlisted creators yet')}
        </Headline>
        <Body
          size="md"
          color={designSystemToken('semantic.fg.secondary')}
          className={styles.description}
        >
          {translate(
            'Use the heart icon in the row menu or bulk actions bar to shortlist applications you want to revisit.'
          )}
        </Body>
      </div>
    </div>
  );
}

export default ShortlistEmptyState;
